/* global firebase */
import { SET_CURRENT_REQUEST, RESOLVE_CURRENT_REQUEST } from "./mutations.js";
const state = {
  current_request: null
};
const getters = {
  get_current_request: state => {
    if (state.current_request !== null) return state.current_request;
    return {};
  }
};

const mutations = {
  [SET_CURRENT_REQUEST](state, data) {
    state.current_request = data;
  },
  [RESOLVE_CURRENT_REQUEST](state) {
    state.current_request = null;
  }
};
const actions = {
  async load_current_request({ commit, getters }) {
    if (!getters.get_current_request.id) return;
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection("products")
        .doc(getters.get_current_request.id)
        .get()
        .then(doc_snapshot => {
          if (!doc_snapshot.exists) reject("non-existent");
          else {
            let data = {
              id: doc_snapshot.data().id,
              title: doc_snapshot.data().title,
              description: doc_snapshot.data().description,
              conditions: doc_snapshot.data().conditions
            };

            commit(SET_CURRENT_REQUEST, data);
          }
        })
        .catch(() => {});
    });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
